/**
 * Lifecycle status of a contract event in the partner's ledger.
 *
 * Mirrors the backend enum {@code com.mvs.backend.pd.enums.PdContractEventStatus} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum PdContractEventStatusEnum {
    PENDING,
    OBSOLETE,
    SENT,
}
